function throttle(func, delay) {
  let timer = null;

  return function() {
    const context = this,
      args = arguments;

    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
}

export default throttle;
